<template>
  <modal
    :show="show"
    header-classes="justify-content-center center"
    @close="handleClose()"
  >
    <h4 slot="header">
      New Bible Study
    </h4>

    <BSForm
      ref="childBSFormComponent"
      :bible-study="bibleStudy"
      :participants="participants"
      :all-fields="true"
      :disable-leader="true"
      @returnBSData="saveBS($event)"
    />

    <template slot="footer">
      <p-button @click="handleClose()">
        Cancel
      </p-button>
      <p-button class="custom-modal-type" @click="$refs.childBSFormComponent.validateInput()">
        Save
      </p-button>
    </template>
  </modal>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {
    mapState, mapGetters, vuex
} from 'vuex';
import modal from '../UIComponents/Modal';
import BSForm from './Form.vue';

export default {
    name: 'NewBSModal',
    components: {
        modal,
        BSForm
    },
    data() {
        return {
            namespace: 'BibleStudies',
        };
    },
    props: {
        show: Boolean,
        participants: Array,
        bibleStudy: Object,
    },
    computed: {
        ...mapState({
            error: (state) => state.BibleStudies.error,
        }),
    },
    methods: {
        saveBS(BSData) {
            this.$store.dispatch(`${this.namespace}/storeNewBibleStudy`, {
                bible_study_data: BSData.bible_study_data,
                bible_study_schedule_data: BSData.bible_study_schedule_data,
                bible_study_participants_list: BSData.bible_study_participants_list,
            }).then((id) => {
                this.$router.push({ name: 'BibleStudiesView', params: { id } });
            });
        },
        handleClose() {
            this.$refs.childBSFormComponent.handleClose();
            this.$emit('close');
        },
    },
};
</script>
<style>
.modal-body{
    display: flex;
    justify-content: center;
}
.modal-body{
    display: flex;
    flex-direction: column;
    padding: 20px 10px;
}
.col-md-4{
    margin: auto;
}
.select-default.el-select.light-gray .el-input input {
    border-color: #DCDFE6 !important;
    border-width: 1px;
}
.select-default.el-select.light-gray .el-input:hover input:hover,
.select-default.el-select.light-gray .el-input:hover input, .select-default.el-select .el-input:hover .el-input__icon{
    border-color: #66615B !important;
}
.noError {
  border-left: 5px solid white;
}
.validationError {
  border-left: 5px solid red;
  background-color: lightpink;
  font-weight: bold;
}
.validationErrorText {
  color: red;
  font-weight: bold;
  margin: 3px 0 10px 0;
  text-align: center;
}
#datepick, .datepick {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
}
.btn.custom-modal-type{
  background-color: #409EFF;
}
.btn:hover.custom-modal-type:hover{
  background-color: #66b1ff !important;
}
</style>

<style scoped>
</style>
